import { ReactNode } from 'react';

import { css, cx } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { NumberInputWithSuffix, type NumberInputWithSuffixProps } from './number-input-with-suffix';

export interface NumberInputWithFrameProps extends Omit<NumberInputWithSuffixProps, 'suffix' | 'className' | 'prefix'> {
  className?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
  currency?: string;
  /** true면 frame border/padding 없이 내용만 렌더 */
  customStyle?: boolean;
}

/**
 * Framed number input without clear (X) button.
 * Same chrome as ClearableNumberInputWithFrame; use when clear affordance is not needed.
 */
export const NumberInputWithFrame = ({
  className,
  prefix,
  suffix,
  currency,
  customStyle,
  ...props
}: NumberInputWithFrameProps) => {
  return (
    <div className={cx(className, hstack(), !customStyle && frameStyle)}>
      {prefix}
      <NumberInputWithSuffix {...props} />
      {suffix}
      {currency && <span translate='no'>{currency}</span>}
    </div>
  );
};

const frameStyle = css({
  h: 48,
  px: 12,
  textStyle: 'Text/L/Monospace/Regular',
  color: 'content.default.level-5',
  border: '1px solid',
  borderColor: 'border.default.level-2',
  borderRadius: 8,
  transition: 'border-color 200ms',
  _hover: {
    borderColor: 'border.default.level-4',
  },
  _focusWithin: {
    borderColor: 'border.default.level-4',
  },
});
